export enum HospitalPrescriptionEventTypes {
  Created = 1,
  Filled,
  Transferred,
  Recalled,
  Refilled,
  Cancelled,
  TransferDenied,
  RuledOutOfScopeForOnlineFulfillment,
}

export enum HospitalAllPrescriptionEventTypes {
  Created  = 1,
  Approved = 9,
  Declined = 10,
  Cancelled = 6,
  RefillRequested = 11,
  RefillAbandoned = 13,
  RefillCancelled = 12,
  InvoiceCreated = 14,
  Filled = 2,
  InvoiceCancelled = 15,
  Transferred = 3,
  Recalled = 4,
  Refilled = 5,
  TransferDenied = 7,
  RuledOutOfScopeForOnlineFulfillment = 8
}

export namespace HospitalAllPrescriptionEventTypes {
  export const eventFormattedName = (event: string | number | undefined) => {
    if (!event) return 'Unknown';

    switch (event) {
      case HospitalAllPrescriptionEventTypes.InvoiceCancelled:
        return 'Invoice Cancelled';
      default:
        return event;
    }
  };
}
